import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from } from "rxjs";
import { eContracts } from "../contract.config";
import { eCurrencies } from "app/common/ui/info-icon/info-icon.interface";

@Injectable({
    providedIn: 'root'
})

export class LootboxesContractService {
    public contract;
    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.Lootbox);
        // this.contractsService.getContractIstances(eContracts.Lootbox).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract(eContracts.Lootbox);

    }

    buyItem(ownerAddress: string, boxId: string, amount: number, currency: eCurrencies = eCurrencies.KMON, candiesPrice?: number): Observable<any> {
        if (currency === eCurrencies.CANDIES) {
            let priceInwei =this.web3Service.toWei(amount * candiesPrice/* , 'wei' */);
            return from(this.contract.methods.buyItemWithCandies(ownerAddress, boxId, amount, priceInwei).send({
                ...this.contractsService.additionalParameters(),
                from: ownerAddress
            }));
        } else {
            let _currency = eContracts[currency];
            let currencyAddress: string = this.contractsService.getContractAddress(_currency);
            return from(this.contract.methods.buyItem(ownerAddress, boxId, amount, currencyAddress).send({
                ...this.contractsService.additionalParameters(),
                from: ownerAddress
            }));
        }
    }
}